module.exports = __webpack_public_path__ + "0484ed06130f0a74e4a9397aa6e324f9.pdf";